var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: "新建任务",
            visible: _vm.drawer,
            modal: true,
            "wrapper-closable": false,
            "before-close": _vm.handleClose,
            "append-to-body": true,
            size: "1120px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                "label-width": "110px",
                rules: _vm.rule,
              },
            },
            [
              _c(
                "div",
                { staticClass: "left-card" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "任务名称：", prop: "name" } },
                    [
                      _c("el-input", {
                        staticClass: "input-item",
                        attrs: {
                          maxlength: "100",
                          "show-word-limit": "",
                          placeholder: "请输入任务名称",
                        },
                        model: {
                          value: _vm.formData.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "name", $$v)
                          },
                          expression: "formData.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "关联项目：",
                                prop: "program_id",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "small",
                                    clearable: "",
                                    placeholder: "请选择关联项目",
                                    filterable: "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleContract(
                                        _vm.formData.program_id,
                                        _vm.formData
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.formData.program_id,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "program_id", $$v)
                                    },
                                    expression: "formData.program_id",
                                  },
                                },
                                _vm._l(_vm.projectList, function (item) {
                                  return _c(
                                    "el-option",
                                    {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    },
                                    [
                                      _c("div", [
                                        _c("span", [
                                          _vm._v(_vm._s(item.label)),
                                        ]),
                                        _vm._v(" "),
                                        item.status == 1 || item.status == 2
                                          ? _c(
                                              "span",
                                              {
                                                class:
                                                  item.status == 1
                                                    ? "program-stop"
                                                    : "program-close",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.status == 1
                                                      ? "已暂停"
                                                      : "已关闭"
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "select-bar",
                              attrs: { label: "负责人：" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "small",
                                    filterable: "",
                                    placeholder: "请选择负责人",
                                  },
                                  model: {
                                    value: _vm.formData.uid,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "uid", $$v)
                                    },
                                    expression: "formData.uid",
                                  },
                                },
                                _vm._l(
                                  _vm.programMemberOptions,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.name,
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "select-bar",
                              attrs: { label: "计划时间：" },
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  size: "small",
                                  type: "daterange",
                                  clearable: "",
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd",
                                  placeholder: "请选择项目计划结束日期",
                                  "range-separator": _vm.$t("toptable.to"),
                                  "start-placeholder":
                                    _vm.$t("toptable.startdate"),
                                  "end-placeholder": _vm.$t(
                                    "toptable.endingdate"
                                  ),
                                },
                                on: { change: _vm.onchangeTime },
                                model: {
                                  value: _vm.timeVal,
                                  callback: function ($$v) {
                                    _vm.timeVal = $$v
                                  },
                                  expression: "timeVal",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "select-bar",
                              attrs: { label: "协作者：" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "small",
                                    multiple: "",
                                    filterable: "",
                                    "collapse-tags": "",
                                    placeholder: "指派协作者",
                                  },
                                  model: {
                                    value: _vm.formData.members,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "members", $$v)
                                    },
                                    expression: "formData.members",
                                  },
                                },
                                _vm._l(
                                  _vm.programMemberOptions,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.name,
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _c("ueditorFrom", {
                        ref: "ueditorFrom",
                        tag: "ueditor-form",
                        attrs: {
                          border: true,
                          height: "560px",
                          content: _vm.content,
                        },
                        on: { input: _vm.ueditorEdit },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right-card" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "父级任务：", prop: "path" } },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.programOptions,
                          props: { checkStrictly: true },
                          "collapse-tags": "",
                          clearable: "",
                          filterable: "",
                        },
                        on: { change: _vm.handleRemove },
                        model: {
                          value: _vm.formData.path,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "path", $$v)
                          },
                          expression: "formData.path",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticClass: "select-bar", attrs: { label: "优先级：" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { size: "small", placeholder: "请选择优先级" },
                          model: {
                            value: _vm.formData.priority,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "priority", $$v)
                            },
                            expression: "formData.priority",
                          },
                        },
                        _vm._l(_vm.priorityOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "关联版本：", prop: "version_id" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "80%" },
                          attrs: {
                            size: "small",
                            clearable: "",
                            placeholder: "请选择关联版本",
                            filterable: "",
                          },
                          model: {
                            value: _vm.formData.version_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "version_id", $$v)
                            },
                            expression: "formData.version_id",
                          },
                        },
                        _vm._l(_vm.programVersionList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "pointer settings",
                          on: { click: _vm.setVersion },
                        },
                        [_vm._v("设置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "button from-foot-btn fix btn-shadow" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.handleConfirm(1)
                    },
                  },
                },
                [_vm._v("保存并继续新建")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleConfirm()
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            top: "13%",
            title: "版本设置",
            "append-to-body": true,
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleCloseVersion,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "draggable",
            {
              staticClass: "drag-area",
              on: {
                start: function ($event) {
                  _vm.dragging = true
                },
                end: function ($event) {
                  _vm.dragging = false
                },
              },
              model: {
                value: _vm.inputs,
                callback: function ($$v) {
                  _vm.inputs = $$v
                },
                expression: "inputs",
              },
            },
            _vm._l(_vm.inputs, function (input, index) {
              return _c(
                "div",
                { key: index, staticClass: "input-row" },
                [
                  _c("i", { staticClass: "iconfont icontuodong pointer" }),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: { placeholder: "请输入版本名称" },
                    model: {
                      value: input.name,
                      callback: function ($$v) {
                        _vm.$set(input, "name", $$v)
                      },
                      expression: "input.name",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "pointer",
                      on: {
                        click: function ($event) {
                          return _vm.removeInput(index)
                        },
                      },
                    },
                    [_vm._v("-")]
                  ),
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "add-input pointer", on: { click: _vm.addInput } },
            [
              _c("i", { staticClass: "el-icon-plus" }),
              _vm._v(" "),
              _c("span", [_vm._v("添加版本")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCloseVersion } }, [
                _vm._v("取 消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitVersion },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }